import React from "react";
import QRSignupCard from "../../components/QRSignUp/QRSignupCard";
import "../Auth/Login.css"

function QRSignup() {
  return (
    <div className="signup-wrapper">
      <div className="login-container">
        <QRSignupCard/>
      </div>
    </div>
  );
}

export default QRSignup;